import { FlowStepId } from '../woz-flow.types';
import type { FlowStepDefinition, FlowStepRef } from '../woz-flow.types';

export const describeComplaintsStep: FlowStepDefinition = {
  id: FlowStepId.DescribeComplaints,
  type: 'input',
  text: 'Vertel in je eigen woorden waarom je denkt dat de WOZ-waarde te hoog is. Denk bijvoorbeeld aan achterstallig onderhoud, gebreken aan de woning, overlast van een drukke weg, of een andere reden.',
  contextKey: 'complaints',
};

const REPEAT_TEXT = 'Beschrijf je volgende bezwaar in je eigen woorden:';

/** Create a describe-complaints input step for an additional round. */
export function createDescribeComplaintsRepeatStep(): FlowStepDefinition {
  return {
    id: FlowStepId.DescribeComplaints,
    type: 'input',
    text: REPEAT_TEXT,
    contextKey: 'complaints',
  };
}

/** Rehydrate a describe-complaints step from a persisted FlowStepRef. */
export function rehydrateDescribeComplaintsStep(ref: FlowStepRef): FlowStepDefinition {
  return {
    id: FlowStepId.DescribeComplaints,
    sequence: ref.sequence,
    meta: ref.meta,
    type: 'input',
    text: REPEAT_TEXT,
    contextKey: 'complaints',
  };
}
